import { Button, Card, Checkbox, Col, Form, message, Row } from "antd";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import cmaApi from "../../../../../api/cmaApi";
import InputField from "../../../../../components/InputField";
import InputNumberWrap from "../../../../../components/InputNumber";
import Loading from "../../../../../components/Loading";
import TopContent from "../../../../../components/TopContent";
import PageWrap from "../../../../../layout/PageWrap";
import { appRoutes } from "../../../../../routes/routes";
import { formItemLayoutSm } from "../../../../../utils/constants";
import { messages } from "../../../../../utils/messages";

interface MetricsFormProps {
  type: number;
}

const MetricsForm: FC<MetricsFormProps> = ({ type }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id } = useParams();

  const { data, isLoading } = useQuery(
    ["cma_landing_metrics", id],
    () => cmaApi.getLandingMetricDetails(id),
    { enabled: type === 2 }
  );

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const mutationEdit = useMutation(cmaApi.editLandingMetric, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.updateSuccess);
        await queryClient.invalidateQueries("cma_landing_metrics");
        navigate(appRoutes.CMA.LANDING.METRICS.LIST);
      } else message.error(res?.data?.message ?? messages.error);
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const mutationAdd = useMutation(cmaApi.addLandingMetric, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.addSuccess);
        await queryClient.invalidateQueries("cma_landing_metrics");
        navigate(appRoutes.CMA.LANDING.METRICS.LIST);
      } else message.error(res?.data?.message ?? messages.error);
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    const payload = {
      ...dt,
      hienthi:
        dt?.hienthi ??
        (type === 2 ? data?.data?.hienthi ?? false : false),
    };
    if (type === 2) mutationEdit.mutate({ id, data: payload });
    if (type === 1) mutationAdd.mutate(payload);
  };

  return (
    <PageWrap
      title="CMA · Chỉ số"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Chỉ số</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm} className="slider-form">
                  <InputField
                    label="Value"
                    name="value"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.value}
                    errorMsg={errors?.value?.message}
                    rules={{ required: "Vui lòng nhập value" }}
                    placeholder="8+"
                  />
                  <InputField
                    label="Label (VI)"
                    name="label_vi"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.label_vi}
                    errorMsg={errors?.label_vi?.message}
                    rules={{ required: "Vui lòng nhập label" }}
                  />
                  <InputField
                    label="Label (EN)"
                    name="label_en"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.label_en}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="stt"
                    control={control}
                    defaultValue={data?.data?.stt ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("stt", 1);
                    }}
                    min={1}
                  />
                  <Form.Item className="checkbox">
                    <Row>
                      <Col xs={24} sm={20}>
                        <Checkbox
                          defaultChecked={data?.data?.hienthi}
                          name="hienthi"
                          onClick={(e: any) => {
                            setValue("hienthi", e.target.checked);
                          }}
                        />
                        &nbsp;Hiển thị
                      </Col>
                    </Row>
                  </Form.Item>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() =>
                          navigate(appRoutes.CMA.LANDING.METRICS.LIST)
                        }
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default MetricsForm;
